import { ref } from 'vue';

import { useBaseStationsStore } from '@/stores/baseStations';
import { useSubNetworksStore } from '@/stores/subNetworksStore';


export const useSubNetworkMountpointsFilter = (mountpointsSelected, updateFunc) => {
	const subNetworkSelect = ref();
	const baseStationsStore = useBaseStationsStore();
	const subNetworksStore = useSubNetworksStore();

	const setMountpointsForSubnetwork = value => {
		if (value == null) {
			mountpointsSelected.value = [];
			return;
		}
		const subNetwork = subNetworksStore.getSubNetworkById(value);
		if (subNetwork == null) {
			mountpointsSelected.value = [];
			return;
		}
		const baseStationIds = subNetwork.base_stations.map(item => item.id);
		const mountpoints = baseStationsStore.items.filter(item => baseStationIds.includes(item.id)).map(item => item.mntpnt_int).sort((a, b) => a.localeCompare(b));
		mountpointsSelected.value = mountpoints;
		updateFunc();
	};

	const setSubnetworkOnMountpointsChange = () => {
		subNetworkSelect.value.selectedId = null;
		updateFunc();
	};

	return {
		subNetworkSelect,
		setMountpointsForSubnetwork,
		setSubnetworkOnMountpointsChange,
	};
};
